import React, { Component } from 'react'
import MUIDataTable from 'mui-datatables'
import gql from 'graphql-tag'
import { Query, withApollo } from 'react-apollo'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import moment from 'moment'
import getAccountType from '../../../../utils/getAccountType'
import Loader from '../../../../components/common/Loader'
import getLoginId from '../../../../utils/getLoginId'
import { withRouter } from 'react-router'

const GET_ALL_BILLS = gql`
  query getAllPIAndInvoice($clientLoginId: Int, $paymentStatus: [Int!]) {
    allInvoiceData: getAllPIAndInvoice(
      clientLoginId: $clientLoginId
      paymentStatus: $paymentStatus
    ) {
      paymentMasterDetails {
        id
        paymentStatus
        proFormaInvoiceId
        invoiceId
        billedDate
      }
      clientDetails {
        clientName
        contactPerson
        contactNumber
        wallet
      }
      partnerDetails {
        id
        businessName
      }
      billingDetails {
        totalAmount
        totalAmountGST
        totalAmountToBePaidGST
        totalAmountPaidGST
      }
      subscriptionBillDetails {
        subscriptionId
      }
    }
  }
`

const CREATE_INVOICE = gql`
  mutation($id: Int!, $status: Int!) {
    updateAndRaiseInvoice(id: $id, paymentStatus: $status)
  }
`

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  }
})

function TabContainer(props) {
  return <Typography component="div">{props.children}</Typography>
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
}

class Invoices extends Component {
  state = {
    allInvoiceData: null,
    paymentStatus: [0],
    currentTab: 'UN_PAID',
    tableRowData: [],
    isDataLoading: true
  }
  /**
   * @summary Handles payment status value
   *  0 - default - Not paid
   *  1 - PI raised
   *  2-  accounts approval
   *  3-  accounts rejected
   *  4 - payment Done - Full payment
   *  5 - on hold
   *  6 - partial payment
   * **/
  handleTabChange = (event, value) => {
    let paymentStatus
    switch (value) {
      case 'UN_PAID':
        paymentStatus = [0]
        break
      case 'PARTIAL_PAID':
        paymentStatus = [6]
        break
      case 'FULL_PAID':
        paymentStatus = [4]
        break
      default:
        paymentStatus = [0]
    }

    this.setState(
      {
        currentTab: value,
        isDataLoading: false,
        paymentStatus
      },
      () => {
        this.getAllBills()
        this.setLocalStorageVariables()
      }
    )
  }

  // getClolumns = getClolumns => {
  //   if (this.state.currentTab === 'FULL_PAID') {
  //     return (
  //       this.columns = [
  //         'PI No',
  //         'Client Name',
  //         'Amount Paid(Incl. GST)',
  //         'Billing Date'
  //       ]
  //     )
  //   } else {
  //     return (
  //       this.columns = [
  //         'PI No',
  //         'Client Name',
  //         'Amount To Be Paid(Incl. GST)',
  //         'Billing Date'
  //       ]
  //     )
  //   }
  // }

  // this function is added to load columns based on the current tabs for mui data table

  getClolumns = getClolumns => {
    if (this.state.currentTab === 'FULL_PAID') {
      return (this.columns = [
        'PI No',
        'Client Name',
        'Amount Paid(Incl. GST in Rs)',
        'Billing Date'
      ])
    } else if (this.state.currentTab === 'PARTIAL_PAID') {
      return (this.columns = [
        'PI No',
        'Client Name',
        'Amount To Be Paid(Incl. GST in Rs)',
        'Amount Paid(Incl. GST in Rs)',
        'Billing Date'
      ])
    } else {
      return (this.columns = [
        'PI No',
        'Client Name',
        'Amount To Be Paid(Incl. GST in Rs)',
        'Billing Date'
      ])
    }
  }

  // columns = [
  //   'PI No',
  //   'Client Name',
  //   'Amount To Be Paid(Incl. GST)',
  //   'Billing Date'
  // ]

  // fullypaidcolumns = [
  //   'PI No',
  //   'Client Name',
  //   'Amount Paid(Incl. GST)',
  //   'Billing Date'
  // ]
  options = {
    print: false,
    filterType: 'dropdown',
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 15,
    onRowClick: (rowData, { rowIndex, dataIndex }) => {
      console.log('row click data:', rowData, rowIndex, dataIndex)
      console.log('all incoice data', this.state.allInvoiceData[dataIndex])
      // if([])
      if (
        ['UN_PAID', 'PARTIAL_PAID', 'FULL_PAID'].includes(this.state.currentTab)
      ) {
        console.log(
          'allInvoiceData index',
          this.state.allInvoiceData[dataIndex].paymentMasterDetails.id
        )
        this.createProformaInvoice(
          this.state.allInvoiceData[dataIndex].paymentMasterDetails.id
        )
      }
    }
    // textLabels: {
    //   body: {
    //     noMatch: this.state.isDataLoading
    //       ? <Loader />
    //       : 'Sorry, there is no matching data to display'
    //   }
    // }
  }

  makePayment = id => {
    console.log('id is', id)
    this.props.history.push({
      pathname: '/home/manage/makePayment/' + id
    })
  }

  handleButtonClick = async (id, paymentStatus) => {
    await this.props.client.mutate({
      mutation: CREATE_INVOICE,
      variables: {
        id: parseInt(id, 10),
        status: paymentStatus
      },
      errorPolicy: 'all',
      update: (cache, { data: { updateAndRaiseInvoice } }) => {
        if (updateAndRaiseInvoice) {
          let { getAllPIAndInvoice: bills } = cache.readQuery({
            query: GET_ALL_BILLS,
            variables: {
              paymentStatus: this.state.paymentStatus
            }
          })

          if (paymentStatus === 3) {
            bills = bills.filter(bill => bill.id !== id)
          } else if (paymentStatus === 5) {
            bills = bills.map(bill => {
              if (bill.id === id) {
                bill.paymentStatus = 5
              }
              return bill
            })
          }

          cache.writeQuery({
            query: GET_ALL_BILLS,
            variables: {
              paymentStatus: this.state.paymentStatus
            },
            data: { getAllPIAndInvoice: bills }
          })
        }
      }
    })

    this.setState({
      invoiceAmount: '',
      paymentStatus: '',
      discount: '',
      remarks: ''
    })

    this.props.history.push({
      pathname: '/home/manage/admin/InvoiceDetails'
    })
  }

  getFormattedDate = timestamp => {
    moment(parseInt(timestamp, 10)).format('MMM Do YY')
    // .unix()
    // .toString()
  }

  epochToDate = date1 => {
    const d1 = parseInt(date1, 10)
    const unixEpochTimeMS = d1 * 1000
    const d = new Date(unixEpochTimeMS)
    // Careful, the string output here can vary by implementation...
    const strDate = d.toLocaleDateString()
    return strDate
  }

  createProformaInvoice = id => {
    this.props.history.push({
      pathname: '/home/manage/admin/CreateProformaInvoice/' + id
    })
  }

  histroyPacketRcv = () => {
    this.props.history.push({
      pathname: '/home/manage/histroyPacketRcv'
    })
  }

  billingDays = () => {
    this.props.history.push({
      pathname: '/home/manage/billingDays'
    })
  }

  makeAdvanceAmount = () => {
    this.props.history.push({
      pathname: '/home/manage/makeAdvanceAmount'
    })
  }

  billingHistoryReport = () => {
    this.props.history.push({
      pathname: '/home/manage/billingHistoryReport'
    })
  }

  /**
   * @summary Reduce query data to Table Row Data
   *  0 - default - Not paid
   *  1 - PI raised
   *  2-  accounts approval
   *  3-  accounts rejected
   *  4 - payment Done - Full payment
   *  5 - on hold
   *  6 - partial payment
   * **/
  mapToArr(allInvoiceData) {
    let rowData = []
    let tableRowData = []

    allInvoiceData.forEach(element => {
      rowData = []
      rowData.push(element.paymentMasterDetails.proFormaInvoiceId)
      element.clientDetails
        ? rowData.push(element.clientDetails.clientName)
        : rowData.push(element.partnerDetails.businessName)
      if (
        this.state.currentTab === 'PARTIAL_PAID' ||
        this.state.currentTab === 'UN_PAID'
      ) {
        rowData.push(element.billingDetails.totalAmountToBePaidGST)
      } else if (this.state.currentTab === 'FULL_PAID') {
        rowData.push(element.billingDetails.totalAmountPaidGST)
      }
      if (this.state.currentTab === 'PARTIAL_PAID') {
        rowData.push(element.billingDetails.totalAmountPaidGST)
      }
      // rowData.push(element.paymentMasterDetails.billedDate)
      rowData.push(this.epochToDate(element.paymentMasterDetails.billedDate))
      // rowData.push(this.getFormattedDate(element.paymentMasterDetails.billedDate))
      // if (element.paymentMasterDetails.paymentStatus === 0) {
      //   const status = 'Unpaid'
      //   rowData.push(status)
      // }
      // if (element.paymentMasterDetails.paymentStatus === 6) {
      //   const status = 'Partially Paid'
      //   rowData.push(status)
      // }
      // if (element.paymentMasterDetails.paymentStatus === 4) {
      //   const status = 'Paid'
      //   rowData.push(status)
      // }
      // rowData.push(element.totalVehicles)
      // rowData.push(element.totalPI)
      // rowData.push(element.clientCredit)
      // rowData.push(this.getFormattedDate(element.billGeneratedDate))
      //   if (element.paymentStatus === 3) {
      //     rowData.push(
      //       <Button
      //         onClick={e => {
      //           e.stopPropagation()
      //           this.makePayment(element.id)
      //         }}
      //       >
      //         PAY
      //       </Button>
      //     )
      //   } else if (element.paymentStatus === 4) {
      //     rowData.push('Paid')
      //   } else if (element.paymentStatus === 5) {
      //     rowData.push('On Hold')
      //   } else {
      //     rowData.push(
      //       <Button
      //         variant="outlined"
      //         onClick={e => {
      //           e.stopPropagation()
      //           const status = !['SER'].includes(getAccountType()) ? 3 : 5
      //           this.handleButtonClick(element.id, status)
      //         }}
      //       >
      //         {!['SER'].includes(getAccountType()) ? 'RAISE' : 'HOLD'}
      //       </Button>
      //     )
      //   }

      tableRowData.push(rowData)
    })
    console.log(
      'table row data',
      tableRowData,
      typeof moment(parseInt('1577711247', 10)).format('MMM Do YY')
    )
    this.setState({ tableRowData })
  }

  getAllBills = async () => {
    console.log('call get all bills')
    const { loading, data } = await this.props.client.query({
      query: GET_ALL_BILLS,
      variables: {
        // clientLoginId: getLoginId(),
        // clientLoginId: 20,
        paymentStatus: this.state.paymentStatus
      },
      fetchPolicy: 'network-only'
    })
    this.setState(
      { isDataLoading: loading, allInvoiceData: data.allInvoiceData },
      () => {
        // console.log('lodaing', loading)
      }
    )
    this.mapToArr(data.allInvoiceData)
  }

  setLocalStorageVariables = () => {
    sessionStorage.setItem('clientSubTabValue', this.state.currentTab)
  }

  getLocalStorageVariables = () => {
    const _tabvalue = sessionStorage.getItem('clientSubTabValue')
    // console.log('get from local', _tabvalue)
    this.setState(
      {
        currentTab: _tabvalue
      },
      () => {
        this.handleTabChange(null, this.state.currentTab)
        // console.log('sub tab vlaue:', this.state.currentTab)
      }
    )
  }

  componentDidMount = () => {
    this.getAllBills()
    if (!sessionStorage.getItem('clientSubTabValue')) {
      this.setState(
        {
          currentTab: 'UN_PAID'
        },
        () => {
          this.setLocalStorageVariables()
        }
      )
    } else {
      this.getLocalStorageVariables()
    }
  }

  render() {
    const { classes } = this.props
    const { currentTab, tableRowData, isDataLoading } = this.state
    if (isDataLoading) {
      return <Loader />
    } else {
      return (
        <div className={classes.root}>
          {/* {console.log('data loader', isDataLoading)} */}
          <Grid container spacing={16} direction="row" justify="space-between">
            {/* <Grid item>
              <Typography variant="headline">PI and Invoices</Typography>
            </Grid> */}

            <Grid item>
              <Grid container spacing={16}>
                {!['ACC'].includes(getAccountType()) && (
                  <Grid item>
                    <Button
                      color="secondary"
                      variant="contained"
                      className={classes.button}
                      onClick={this.histroyPacketRcv}
                    >
                      History Of Packet Received
                    </Button>
                  </Grid>
                )}

                {!['ACC'].includes(getAccountType()) && (
                  <Grid item>
                    <Button
                      color="secondary"
                      variant="contained"
                      className={classes.button}
                      onClick={this.billingDays}
                    >
                      No. Of Billing Days
                    </Button>
                  </Grid>
                )}

                {!['ACC'].includes(getAccountType()) && (
                  <Grid item>
                    <Button
                      color="secondary"
                      variant="contained"
                      className={classes.button}
                      onClick={this.makeAdvanceAmount}
                    >
                      Make Advance Amount
                    </Button>
                  </Grid>
                )}

                {!['ACC'].includes(getAccountType()) && (
                  <Grid item>
                    <Button
                      color="secondary"
                      variant="contained"
                      className={classes.button}
                      onClick={this.billingHistoryReport}
                    >
                      Billing History Reports
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid>
            <AppBar position="static">
              <Tabs value={currentTab} onChange={this.handleTabChange}>
                <Tab value="UN_PAID" label="UnPaid Invoices" />
                {!['SER'].includes(getAccountType()) && (
                  <Tab value="PARTIAL_PAID" label="Partially Paid Invoices" />
                )}

                {!['SER'].includes(getAccountType()) && (
                  <Tab value="FULL_PAID" label="Fully Paid Invoices" />
                )}
              </Tabs>
            </AppBar>

            {this.state.isDataLoading ? (
              <Loader />
            ) : (
              <TabContainer>
                <MUIDataTable
                  data={tableRowData}
                  columns={this.getClolumns()}
                  options={this.options}
                />
              </TabContainer>
            )}
            {/* <TabContainer>
              {isDataLoading ? (
                <Loader />
              ) : (
                <MUIDataTable
                  data={tableRowData}
                  columns={this.getClolumns()}
                  options={this.options}
                />
              )}
            </TabContainer> */}
          </Grid>
        </div>
      )
    }
  }
}

// export default withStyles(style)(withApollo(InvoiceDetails))
Invoices.PropTypes = {
  classes: PropTypes.object.isRequired
}

export default withRouter(withStyles(style)(withApollo(Invoices)))



// WEBPACK FOOTER //
// ./src/components/Pages/Billing/InvoiceDetails/Invoices.jsx